module.exports = __webpack_public_path__ + "static/media/chapa-y-pintura.20e86bd9.png";